module.exports = __webpack_public_path__ + "static/media/image.bc73ee76.svg";